import { useEffect, useState } from "react"
import axiosInstance from "../utils/axiosInstance"

export const useProduct = (productSlug) => {
    const [loading, setLoading] = useState(false)
    const [product, setProduct] = useState(null)

    useEffect(() => {
        setLoading(true)
        axiosInstance
            .get(`api/products-for-store/${productSlug}`).then((res) => {
                console.log(res, 'ressss')
                setProduct(res.data.data)
            })
            .catch((err) => {
                console.log(err)
            })
            .finally(() => {
                setLoading(false)
            })
    }, [productSlug])
    
    return {product, loading}
}